import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { rangeTypesDataSource } from 'infrastructure/data-sources/range-type';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IRangeTypeItem } from 'infrastructure/data-sources/range-type';

type Options = IBaseSelectBoxOption<IRangeTypeItem['id'], IRangeTypeItem>[];

interface IProps
  extends Omit<IBaseSelectBoxProps<IRangeTypeItem['id']>, 'options'> {}

const RangeTypeSelectBox: React.FC<IProps> = (props) => {
  const dataSource = useMemo(() => rangeTypesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default RangeTypeSelectBox;
